import { useRef, useCallback } from "react";

const LONG_PRESS_THRESHOLD = 500;

type UseLongPressOptions = {
  onLongPress: () => void;
};

export function useLongPress({ onLongPress }: UseLongPressOptions) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const didLongPressRef = useRef(false);

  const clear = useCallback(() => {
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const onTouchStart = useCallback(() => {
    if (timerRef.current !== null) clearTimeout(timerRef.current);
    didLongPressRef.current = false;
    timerRef.current = setTimeout(() => {
      didLongPressRef.current = true;
      onLongPress();
    }, LONG_PRESS_THRESHOLD);
  }, [onLongPress]);

  const onTouchEnd = useCallback(() => {
    clear();
  }, [clear]);

  const onTouchMove = useCallback(() => {
    clear();
  }, [clear]);

  const onContextMenu = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault();
  }, []);

  return {
    handlers: { onTouchStart, onTouchEnd, onTouchMove, onContextMenu },
    didLongPressRef,
  };
}
